import { Task } from '@lit/task';
import { css, html, LitElement, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ANY_ROUTE } from '../../../entry-components/course-player/routes';
import { shouldCenterContent } from '../../util/dom-utils';

export interface Route {
  path: string;
  element: () => Promise<TemplateResult>;
}

@customElement('lua-router')
export class LuaRouter extends LitElement {
  static override styles = css`
    :host {
      height: 100%;
      display: block;
    }

    .content {
      height: inherit;
    }

    .center-content {
      display: flex;
      justify-content: center;
      flex-direction: column;
    }
  `;

  @property({ type: String, reflect: true })
  currentRoute = ANY_ROUTE;

  @property({ type: Array })
  routes: Route[] = [];

  loadRoute = new Task(this, {
    task: async ([currentRoute]) => {
      const routeFound = this.routes.find((route) => route.path === currentRoute);

      if (!routeFound) {
        return html`<div>404 Not Found</div>`; // FIXME: This should be a 404 page
      }

      return routeFound?.element();
    },
    args: () => [this.currentRoute],
  });

  routesToBeCentered = ['/complete', '/scorm'];

  protected override render() {
    return this.loadRoute.render({
      pending: () => html`<div>Loading...</div>`, // FIXME: This should be a loading spinner
      complete: (result) =>
        html`<div
          data-testid="content"
          class="content ${shouldCenterContent(this.currentRoute, this.routesToBeCentered) ? 'center-content' : ''}">
          ${result}
        </div>`,
      error: (error) => html`<div>${error}</div>`, // FIXME: This should be a 500 page
    });
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'lua-router': LuaRouter;
  }
}
